import { connectionTypes } from 'config/constants';

const INITIAL_STATE = {
  connection: true,
};

export default function reducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case connectionTypes.CONNECTION_ON:
      return { ...state, connection: true };
    case connectionTypes.CONNECTION_OFF:
      return { ...state, connection: false };
    default:
      return state;
  }
}
